import { ExhibitorProfilesPackNumber, StructureProductType } from "@ac-expo/api-types";
import { getPackFeatures, searchByTerms } from "@ac-expo/utils";
import { FileType } from "@prisma/client";
import { useMemo, useState } from "react";
import Search from "../../Search";
import { ProductCard } from "./ProductCard";

type Product = Pick<StructureProductType, "name" | "description" | "images" | "link">;

export function ProductPanel({
  products,
  getFileUrl,
  exhibitorPackNumber,
}: {
  getFileUrl: (key?: string, type?: FileType, width?: number) => string;
  products?: Product[];
  exhibitorPackNumber?: ExhibitorProfilesPackNumber | null;
}) {
  const packFeatures = getPackFeatures(exhibitorPackNumber);
  const [searchText, setSearchText] = useState("");

  const filteredProducts = useMemo(() => {
    const allProducts = products ?? [];
    if (!searchText.trim()) return allProducts;

    return allProducts.filter((product) =>
      searchByTerms(searchText, [product.name, product.description ?? ""].filter(Boolean)),
    );
  }, [products, searchText]);

  return (
    <div className="size-full space-y-6">
      {(products ?? []).length > 0 && (
        <Search
          className="max-w-sm"
          value={searchText}
          onChangeText={setSearchText}
          onReset={() => setSearchText("")}
          placeholder="Rechercher un produit"
        />
      )}

      <div className="grid lg:grid-cols-2 xl:grid-cols-[repeat(auto-fill,minmax(450px,1fr))] gap-6">
        {filteredProducts.map((product: Product, index) => (
          <ProductCard
            key={index}
            product={product}
            getFileUrl={getFileUrl}
            hasProductLink={packFeatures.hasProductLink}
            canShowCarousel={packFeatures.maxProductImages > 1}
          />
        ))}
      </div>

      {searchText.trim() && filteredProducts.length === 0 && (
        <p className="text-center text-sm text-gray-500">Aucun produit trouvé</p>
      )}
    </div>
  );
}

export default ProductPanel;
